import React, { useContext, useLayoutEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { AuthContext } from '@/layout/Auth'
import MenuView from '@/layout/MenuView'
import APIToken from './APIToken'
import Info from './Info'
import Member from './Member'
import Role from './Role'
import Permission from './Permission'
import Orders from './Orders'
import OrderDetail from './Orders/Details'
import { isAdmin } from '@/hooks'

const Organization = () => {
  const navigate = useNavigate()
  const { authInfo } = useContext(AuthContext)
  const permissions = authInfo?.permissions
  const admin =
    !!permissions &&
    permissions?.findIndex((perm) => isAdmin(perm?.name)) !== -1

  useLayoutEffect(() => {
    if (authInfo?.auth && !authInfo?.loadingOrg) {
      if (
        permissions &&
        !admin &&
        location?.pathname !== '/console/organization/info'
      ) {
        navigate('/console/organization/info')
      }
    }
    //eslint-disable-next-line
  }, [authInfo, admin]);

  return (
    <MenuView>
      <Outlet />
    </MenuView>
  )
}

Organization.APIToken = APIToken
Organization.Info = Info
Organization.Permission = Permission
Organization.Role = Role
Organization.Member = Member
Organization.Orders = Orders
Organization.OrderDetail = OrderDetail

export default Organization
